import Amount from "@/business/myPage/serviceStatistics/Amount";
import Statistics from "@/business/myPage/serviceStatistics/Statisics";
import UsageHistory from "@/business/myPage/serviceStatistics/UsageHistory";
import { LayoutHeader } from "@/Header";
import { Tabs } from "@/Tabs";
import { createFileRoute } from "@tanstack/react-router";
import { useTab } from "^/common/useTab";

export const Route = createFileRoute(
  "/business/layout/user-service-statistics"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { tab, handleTab, tabList } = useTab([
    "통계",
    "정산금액 조회",
    "이용내역",
  ]);
  return (
    <>
      <LayoutHeader title={"서비스 통계"} hasBackBtn hasFootPrint={false} />
      <div className="flex-auto min-w-0 overflow-x-hidden bg-[#F5F5F5]">
        <Tabs tabList={tabList} handleTab={handleTab} tab={tab}>
          <Statistics />
          <Amount />
          <UsageHistory />
        </Tabs>
      </div>
    </>
  );
}
